var render = function (_h,_vm) {var _c=_vm._c;return _c('cell',_vm._g(_vm._b({},'cell',_vm.data.attrs,false),_vm.data.on),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }